/**
 * A utility function that validates a password string against a set of rules.
 *
 * @param value - The password string to validate.
 * @returns An object with boolean properties indicating whether each rule is satisfied.
 */
export const createPasswordValidation = (value: string) => {
  const validLength = /.{10,}/.test(value);
  const includeUppercase = /[A-Z]/.test(value);
  const includeLowercase = /[a-z]/.test(value);

  return { validLength, includeUppercase, includeLowercase };
};
